// extracted by mini-css-extract-plugin
export var container = "recipe-component-module--container--pwKqD";
export var note = "recipe-component-module--note--44v3V";
export var title = "recipe-component-module--title--3ztFe";